import {ButtonPulse} from "./Button";
import {Timer} from "./Timer";
import {GameManager} from "../Managers/GameManager";
import {textureOrDefault} from "../Core/AssetHelpers";
import {ReactionVO, voOptionsButtons} from "../Data/VoiceOver";
import * as PIXI from "pixi.js";
import {VoiceOverManager} from "../Managers/VoiceOverManager";
import {PlayMode} from "html-living-framework";
import {Sprite} from "../Core/Sprite";

export class ButtonPackage extends ButtonPulse {

    public readonly packageTimer = this.visuals.addChild(new Timer(0x492915, 0x492915, 0.8, "erase"));
    private _colorful = false;
    private graySprite = this.visuals.addChild(new Sprite());

    constructor() {
        super();

        const colorHoverVO = ["LetsGoLuna_032", "LetsGoLuna_033"];
        const disableHoverVO = ["LetsGoLuna_054", "LetsGoLuna_055"];
        this.onOver.add(() => {
            if (!PIXI.utils.isMobile.any) {
                const voToUpdate = this._colorful ? colorHoverVO : disableHoverVO;
                const voToPlay = this._colorful ? [...ReactionVO(), voToUpdate[0]] : voToUpdate[0];
                VoiceOverManager.instance.playVO(voToPlay, {
                    ...voOptionsButtons,
                    mode: PlayMode.New,
                    callback: b => {
                        if (b) {
                            voToUpdate.push(voToUpdate.shift()!);
                        }
                    }
                });
            }
        });
    }

    onLayout() {
        this.packageTimer.progress = GameManager.instance.packageProgress;

        this.graySprite.texture = textureOrDefault("button-package-disabled");
        this.graySprite.anchor.set(this.sprite.anchor.x, this.sprite.anchor.y);
        this.graySprite.copyFrom(this.sprite, "x", "y", "width", "height");
        this.graySprite.alpha = this._colorful ? 0 : 1;
        this.sprite.alpha = this._colorful ? 1 : 0;
    }

    startTimer() {
        const gameManager = GameManager.instance;
        this.stopPulse();
        this.packageTimer.progress = gameManager.packageProgress;
        gameManager.onPackageProgress.remove(this);
        if (gameManager.packageProgress < 1) {
            gameManager.onPackageProgress.add(value => {
                this.packageTimer.progress = value;
                if (value < 1) {
                    this.enabled = false;
                } else {
                    this.enabled = true;
                    gameManager.onPackageProgress.remove(this);
                    this.pulse();
                }
            }, this);
        } else {
            this.pulse();
        }
    }

    stopTimer() {
        this.stopPulse();
        GameManager.instance.onPackageProgress.remove(this);
    }

    destroy() {
        GameManager.instance.onPackageProgress.remove(this);
        super.destroy();
    }

    get colorful(): boolean {
        return this._colorful;
    }

    set colorful(value: boolean) {
        if (this._colorful !== value) {
            this._colorful = value;
            this.sprite.killTweens();
            this.graySprite.killTweens();
            this.sprite.alphaTo(value ? 1 : 0, 0.2);
            this.graySprite.alphaTo(value ? 0 : 1, 0.2);
        }
    }
}